var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("app-browse", {
        attrs: {
          "url-query-params": "",
          "data-source": _vm.dataSource,
          "selected-items": _vm.selectedItems,
          "button-bar-items": _vm.buttonBarItems,
          "context-menu-items": _vm.contextMenuItems,
        },
        on: {
          processPayment: function ($event) {
            return _vm.processPayment($event)
          },
          viewPurchase: function ($event) {
            return _vm.viewPurchase($event)
          },
          state: function ($event) {
            _vm.purchaseState = $event
          },
          exportToIsabel: function ($event) {
            return _vm.exportToIsabel($event)
          },
          downloadDocument: function ($event) {
            return _vm.downloadDocument($event)
          },
          exportAsCsv: function ($event) {
            return _vm.exportAsCsv()
          },
          downloadUbl: function ($event) {
            return _vm.downloadUbl($event)
          },
          createUblArchive: function ($event) {
            return _vm.createUblArchive()
          },
          fillDocumentIndexes: function ($event) {
            return _vm.fillDocumentIndexes()
          },
          openDeletedPurchasesModal: function ($event) {
            return _vm.openDeletedPurchasesModal()
          },
        },
      }),
      _c(
        "w-modal",
        {
          staticClass: "w100",
          attrs: {
            value: _vm.$route.path != "/purchase",
            "escape-close": "",
            "full-height": "",
          },
        },
        [
          _c("router-view", {
            key: _vm.$route.path,
            on: {
              update: function ($event) {
                return _vm.updateView()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.quickBankEdit,
            callback: function ($$v) {
              _vm.quickBankEdit = $$v
            },
            expression: "quickBankEdit",
          },
        },
        [
          _c("app-bank-edit", {
            attrs: { purchase: _vm.quickBankEditPurchase },
            on: {
              cancel: function ($event) {
                _vm.quickBankEdit = false
              },
              update: function ($event) {
                _vm.updateView(), _vm.onUpdateBank(), _vm.cancelSelection()
              },
            },
          }),
        ],
        1
      ),
      _vm.exportToIsabelModal
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-purchase-export-to-isabel", {
                attrs: { purchases: _vm.selectedItems },
                on: {
                  close: function ($event) {
                    _vm.exportToIsabelModal = false
                  },
                  complete: function ($event) {
                    return _vm.onExportToIsabelComplete()
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.createUblArchiveModal,
            callback: function ($$v) {
              _vm.createUblArchiveModal = $$v
            },
            expression: "createUblArchiveModal",
          },
        },
        [
          _vm.createUblArchiveModal
            ? _c("app-create-ubl-archive-modal", {
                attrs: {
                  "is-purchase": "",
                  "selected-ids": _vm.ublArchiveSelectedIds,
                },
                on: {
                  done: function ($event) {
                    return _vm.cancelSelection()
                  },
                  close: function ($event) {
                    _vm.createUblArchiveModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.deletedPurchasesModal } },
        [
          _vm.deletedPurchasesModal
            ? _c("app-deleted-purchases-browse", {
                on: {
                  close: function ($event) {
                    _vm.deletedPurchasesModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.ublToPurchaseModal
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-ubl-to-purchase-modal", {
                on: {
                  close: function ($event) {
                    _vm.ublToPurchaseModal = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }